<template>
  <div class="text-center d-inline-flex fluid">
    <v-menu v-model="menu" :close-on-content-click="false" scroll-strategy="none">
      <template v-slot:activator="{ props }">
        <v-btn size="small" variant="text" v-bind="props" :class="{ active: menu }">
          {{ filterName }}
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item v-for="item in items" :key="item.id">
            <v-checkbox
              v-model="item.selected"
              :label="`${item.label} (${item.count})`"
              density="compact"
              hide-details
              @change="onChange"
            ></v-checkbox>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="onOk">
            {{ $t("common.actions.ok") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["filterName", "availableItems", "selectedItems"],
  emits: ["update:selectedItems"],
  data: () => ({
    menu: false,
    items: []
  }),
  created() {
    this.setSelection()
  },
  methods: {
    onOk() {
      this.menu = false
    },
    onChange() {
      const selected = this.items.filter(it => {
        return it.selected
      })
      this.$emit("update:selectedItems", selected)
    },
    setSelection() {
      this.items = this.availableItems
      for (let ix = 0; ix < this.items.length; ix++) {
        const selItem = this.selectedItems.find(si => {
          return si.id === this.items[ix].id
        })
        if (selItem) {
          this.items[ix].selected = true
        } else {
          this.items[ix].selected = false
        }
      }
    }
  },
  watch: {
    menu(newMenuState) {
      if (newMenuState) {
        this.setSelection()
      }
    }
  }
}
</script>

<style>
.v-btn.active .v-icon {
  transform: rotate(-180deg);
}
</style>
